



































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';

@Component({})
class CurvesDialog extends Vue {
  @Global.State('lang') lang;

  @Prop() curves;
  @Prop() updateSelctedCurves;
  @Prop() curves_map;

  selected_curves = [];
  checkbox_color = '#812E81';
  dialog = true;
  search = '';

  // A copy: `curves` is the parent's own list of unselected curves, and sorting it in
  // place reordered the list behind the dialog.
  get sorted_curves() {
    return [...this.curves].sort((curve1, curve2) => `${curve1.name}`.localeCompare(`${curve2.name}`));
  }

  get filtered_curves() {
    const query = (this.search || '').trim().toLowerCase();
    if (!query) return this.sorted_curves;
    return this.sorted_curves.filter((curve) => `${curve.name || ''}`.toLowerCase().includes(query));
  }

  isSelected(curve_id) {
    return this.selected_curves.includes(curve_id);
  }

  toggleCurve(curve_id) {
    this.selected_curves = this.isSelected(curve_id)
      ? this.selected_curves.filter((selected_id) => selected_id !== curve_id)
      : [...this.selected_curves, curve_id];
  }

  closeModal() {
    this.$emit('close');
  }

  confirmAction() {
    this.updateSelctedCurves(this.selected_curves.map((curve_id) => this.curves_map.get(curve_id)));
    this.closeModal();
  }
}

export default CurvesDialog;
